import { useMemo } from "react";
import { useLanguageContext } from "../contexts/LanguageContext";
import { translations, Translations } from "../i18n/translations";

export default function useTranslation(): Translations {
  const { language } = useLanguageContext();
  
  return useMemo(() => translations[language], [language]);
}

